export { default } from './logo-section';
export { default as styles } from './logo-section.styles';
